"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
const react_if_1 = require("react-if");
const hooks_1 = require("../../../../hooks");
const useAwesomeResourceConfig_1 = require("../../../useAwesomeResourceConfig");
const DynamicIntegrationLogo_1 = require("../../../../routes/Private/IntegrationDetail/DynamicIntegrationLogo");
const Option_1 = require("./Option");
const utils_1 = require("@osmosys/utils");
const reusables_1 = require("../../../../comps/reusables");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const DEBUG_EMAIL_LISTS_AND_SEGMENTS = false;
exports.OsmosysResourceSelectBox = (props) => {
    const { fetchPolicy } = props;
    const { currentUser, currentWorkspace } = hooks_1.useOsmosysContext();
    const resourceConfig = useAwesomeResourceConfig_1.useAwesomeResourceConfig(props.resource);
    const { resourceName, resourceNamePlural } = resourceConfig;
    const variables = {};
    let disabled = props.disabled;
    let skip = disabled;
    let placeholder;
    // All the resourcest that depend on integrationId
    if (props.resource === 'emailList' || props.resource === 'emailSegment') {
        // Activated or not
        if (utils_1.isDefined(props.activated)) {
            variables.activated = props.activated;
        }
        const resourcePlaceholderSelect = (react_1.default.createElement(react_1.default.Fragment, null,
            props.multiple ? '' : 'an',
            ' ',
            react_1.default.createElement(react_2.OsmosysChangeCase, { type: "noCase" }, props.multiple ? resourceNamePlural : resourceName)));
        variables.integrationId = props.espId;
        if (!utils_1.isDefined(variables.integrationId)) {
            skip = true;
            disabled = true;
            placeholder = react_1.default.createElement(react_1.default.Fragment, null,
                "Select an ESP to select ",
                resourcePlaceholderSelect);
        }
        else {
            if (props.resource === 'emailSegment') {
                if (utils_1.isDefined(props.listEspId)) {
                    variables.listEspId = props.listEspId;
                }
                else if (utils_1.isDefined(props.listId)) {
                    variables.listId = props.listId;
                }
                else {
                    skip = true;
                    disabled = true;
                    placeholder = (react_1.default.createElement(react_1.default.Fragment, null,
                        "Select an email list to select ",
                        resourcePlaceholderSelect));
                }
            }
        }
    }
    if (props.resource === 'emailTemplateVersion') {
        variables.emailTemplateId = props.emailTemplateId;
        if (!variables.emailTemplateId) {
            skip = true;
            disabled = true;
            placeholder = 'Select a template to select a version';
        }
    }
    if (props.resource === 'integration') {
        if (props.integrationTypes &&
            Array.isArray(props.integrationTypes) &&
            props.integrationTypes.length > 0) {
            variables.integrationTypes = props.integrationTypes;
        }
        else if (props.espsOnly) {
            variables.integrationTypes = [
                'CampaignMonitor',
                'Mailchimp',
                'Mailjet',
                'Sailthru',
                'Salesforce',
                'ActiveCampaign',
            ];
        }
    }
    if (props.resource === 'contentConversion' ||
        props.resource === 'contentFeed' ||
        props.resource === 'contentMapping') {
        if (typeof props.cmsId === 'string' || typeof props.cmsId === 'number') {
            variables.cmsId = props.cmsId;
        }
    }
    if (props.resource === 'contentMapping') {
        if (!variables.cmsId) {
            skip = true;
            disabled = true;
            placeholder = 'Select a CMS to lookup content mappings';
        }
    }
    if (props.resource === 'user' && props.workspaceId) {
        variables.workspaceId = props.workspaceId;
    }
    // if (props.resource === 'email' ) {
    // }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.OsmosysSelectBox, Object.assign({ clearable: props.clearable, resourceName: resourceName, resourceNamePlural: resourceNamePlural, disabled: disabled, skip: skip, placeholder: placeholder, showLabel: typeof props.label === 'boolean' ? props.label : true, boldLabel: props.boldLabel, label: props.labelOverride, fetchPolicy: fetchPolicy }, resourceConfig.selectProps, { selectFirstIfNoValue: props.selectFirstIfNoValue, value: props.value, variables: Object.assign(Object.assign({}, resourceConfig.selectProps.variables), variables), multiple: props.multiple, formatOptionLabel: props.resource === 'email'
                ? (opt) => (react_1.default.createElement(react_2.OsmosysDiv, { flexRow: true },
                    react_1.default.createElement(react_2.OsmosysDiv, { flexColCentered: true, marginRight: true },
                        react_1.default.createElement(react_2.OsmosysIcon, { osysIcon: "email" })),
                    opt.name ||
                        `Email #${opt.emailNumber}`))
                : props.resource === 'integration'
                    ? (opt) => {
                        const integration = opt;
                        return (react_1.default.createElement(Option_1.OsmosysResourceSelectBoxOption, null,
                            react_1.default.createElement(Option_1.OsmosysResourceSelectBoxOption.Icon, null,
                                react_1.default.createElement(react_2.OsmosysTooltip, { label: integration.displayType },
                                    react_1.default.createElement(DynamicIntegrationLogo_1.DynamicIntegrationLogo, { integrationType: integration.integrationType }))),
                            react_1.default.createElement(Option_1.OsmosysResourceSelectBoxOption.Label, null, integration.name),
                            react_1.default.createElement(Option_1.OsmosysResourceSelectBoxOption.Badge, null,
                                react_1.default.createElement("div", null,
                                    integration.integrationType === 'ContentSystem'
                                        ? 'CMS'
                                        : integration.displayType,
                                    react_1.default.createElement(react_if_1.When, { condition: integration.isESP },
                                        ' ',
                                        react_1.default.createElement(reusables_1.EspConnectionStatus, { noText: true, esp: integration }))))));
                    }
                    : props.resource === 'user'
                        ? (opt) => {
                            const user = opt;
                            return (react_1.default.createElement(react_2.OsmosysDiv, { flexRowFilled: true },
                                react_1.default.createElement(react_2.OsmosysDiv, { flexColCentered: true, marginRight: true },
                                    react_1.default.createElement(react_2.OsmosysIcon, { osysIcon: "user" })),
                                react_1.default.createElement(react_2.OsmosysDiv, { flexColCenteredFilled: true }, user.fullName || user.email),
                                react_1.default.createElement(react_if_1.When, { condition: !!(user.id === currentUser.id) },
                                    react_1.default.createElement(react_2.OsmosysDiv, { flexColCentered: true, marginLeft: "sm", className: "small text-muted" }, "(Me)"))));
                        }
                        : props.resource === 'workspace'
                            ? (opt) => {
                                const workspace = opt;
                                return (react_1.default.createElement(react_2.OsmosysDiv, { flexRowFilled: true },
                                    react_1.default.createElement(react_2.OsmosysDiv, { flexColCentered: true, marginRight: true },
                                        react_1.default.createElement(react_2.OsmosysIcon, { osysIcon: "workspace" })),
                                    react_1.default.createElement(react_2.OsmosysDiv, { flexColCenteredFilled: true }, workspace.name),
                                    react_1.default.createElement(react_if_1.When, { condition: !!(workspace.id === currentWorkspace.id) },
                                        react_1.default.createElement(react_2.OsmosysDiv, { flexColCentered: true, marginLeft: "sm", className: "small text-muted" }, "Current workspace"))));
                            }
                            : props.resource === 'emailTemplateVersion'
                                ? (opt) => {
                                    const templateVersion = opt;
                                    return (react_1.default.createElement(react_1.default.Fragment, null,
                                        react_1.default.createElement(Option_1.OsmosysResourceSelectBoxOption, null,
                                            react_1.default.createElement(Option_1.OsmosysResourceSelectBoxOption.Label, null, templateVersion.version),
                                            react_1.default.createElement(react_if_1.Switch, null,
                                                react_1.default.createElement(react_if_1.Case, { condition: !!(props.productionVersionId &&
                                                        `${props.productionVersionId}` ===
                                                            `${templateVersion.id}`) },
                                                    react_1.default.createElement(Option_1.OsmosysResourceSelectBoxOption.Badge, null, "Production version")),
                                                react_1.default.createElement(react_if_1.Case, { condition: !!(props.stagingVersionId &&
                                                        `${props.stagingVersionId}` ===
                                                            `${templateVersion.id}`) },
                                                    react_1.default.createElement(Option_1.OsmosysResourceSelectBoxOption.Badge, null, "Staging version")),
                                                react_1.default.createElement(react_if_1.Case, { condition: !!(props.developmentVersionId &&
                                                        `${props.developmentVersionId}` ===
                                                            `${templateVersion.id}`) },
                                                    react_1.default.createElement(Option_1.OsmosysResourceSelectBoxOption.Badge, null, "Development version"))))));
                                }
                                : DEBUG_EMAIL_LISTS_AND_SEGMENTS &&
                                    (props.resource === 'emailList' ||
                                        props.resource === 'emailSegment')
                                    ? (opt) => (react_1.default.createElement(react_1.default.Fragment, null,
                                        opt.name,
                                        ' ',
                                        react_1.default.createElement(react_2.OsmosysTooltip, { span: true, label: utils_1.isDefined(opt.id)
                                                ? 'Activated for use in Osmosys'
                                                : 'Not activated for use Osmosys' },
                                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { size: "sm", icon: utils_1.isDefined(opt.id) ? pro_solid_svg_icons_1.faCheckCircle : pro_solid_svg_icons_1.faTimesCircle }))))
                                    : undefined, onChange: newVal => {
                if (props.onChange) {
                    props.onChange(newVal);
                }
            } }))));
};
//# sourceMappingURL=OsmosysResourceSelectBox.js.map